var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg/icons.svg#mobile-phone';
                    var viewUrl = 'svg/icons.svg#view-mobile-phone';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 12 20',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };